import { __ } from '@wordpress/i18n'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import { FreeMode, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

export interface SliderProps {
  items: string[]
}

function Slider({ items }: Readonly<SliderProps>) {
  return (
    <Swiper
      breakpoints={{
        786: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      }}
      freeMode={{
        enabled: true,
        sticky: true,
      }}
      modules={[Pagination, Navigation, FreeMode]}
      navigation={{
        enabled: true,
        nextEl: '.swiper-button-custom-next',
        prevEl: '.swiper-button-custom-prev',
      }}
      pagination={{
        el: '.swiper-pagination-custom',
        enabled: true,
        type: 'fraction',
      }}
      slidesPerView={1.25}
      spaceBetween={10}
    >
      {items?.map((item, index) => (
        <SwiperSlide key={index}>
          <div dangerouslySetInnerHTML={{ __html: item }} />
        </SwiperSlide>
      ))}
      <div slot="container-end">
        <div className="relative mt-10 flex w-full justify-center gap-16 font-medium">
          <div className="swiper-button-custom-prev cursor-pointer select-none">
            {__('PREV', 'asavagroup')}
          </div>
          <div className="swiper-pagination-custom w-auto"></div>
          <div className="swiper-button-custom-next cursor-pointer select-none">
            {__('NEXT', 'asavagroup')}
          </div>
        </div>
      </div>
    </Swiper>
  )
}

export default Slider
